<template>
  <div class="policy">
    <div class="tracking-wider border borderColordarkgray2 rounded overflow-hidden px-4 md:px-8 py-6 md:py-8 leading-loose">
      <div class="service">
        <h3 class="text-NotoSansBold text-base lg:text-lg title mb-3 lg:mb-5 px-2 md:text-center font-bold">免責聲明及AI生成內容著作權聲明</h3>

        <div class="privacy-body text-NotoSansRegular text-sm">
          <h5 class="mb-4">本網站的部分內容和功能由生成式人工智慧（Generative AI）技術自動生成。儘管我們致力於提供準確和有價值的學習資源，AI生成的內容可能存在不完整、不準確、或非預期的結果。任何AI 生成的回應或內容，使用者應自行核實其準確性，並謹慎使用。</h5>
          <h5 class="font-bold">免責聲明：</h5>
          <ul class="list-decimal list-inside mt-6 mb-12">
            <li><span class="font-bold">內容準確性：</span>任何生成式 AI 所提供的內容僅供參考，本網站無法保證其完全正確或為最新資訊，使用者須自行予以核實和調整。使用者對於信賴或使用生成之內容所產生的任何形式之糾紛、損失或損害，本網站及其運營方不承擔任何法律責任。</li>
            <li><span class="font-bold">專業建議替代：</span>生成式 AI的回應或內容不應被視為專業建議、法律意見或權威性答案，使用者應根據實際情況尋求獨立之法律意見或其他專業意見。</li>
            <li><span class="font-bold">技術限制：</span>生成式AI 具有其技術上的侷限，生成的回應或內容可能不完全符合使用者需求，並可能會在某些情境下產生不恰當或不妥適的結果。本網站及其運營方無法保證生成內容之完整性或適用性。</li>
          </ul>
          <h5 class="font-bold">智慧財產權聲明：</h5>
          <ul class="list-decimal list-inside mt-6 mb-12">
            <li><span class="font-bold">AI 生成之內容：</span>本網站所使用的生成式 AI 是基於公共訓練數據及開放技術開發，AI 生成的內容不受特定來源或專有數據的控制。由於生成內容的自動性，本網站及其運營方無法對其內容進行完整之第三方智慧財產權檢查或控管，亦無法保證使用者能夠對AI 生成的內容主張著作權等智慧財產權利。</li>
            <li><span class="font-bold">第三方資料的潛在引用：</span>AI 生成的內容有時可能無意識地模仿或引用已存在的資料或作品。若發現有侵犯第三方著作權等智慧財產權的情況，請立即通知本網站，本網站將迅速採取行動，包括移除相關內容。</li>
          </ul>
          <h5 class="font-bold">使用者責任：</h5>
          <ul class="list-decimal list-inside mt-6 mb-12">
            <li>使用者在本網站上創建或傳輸之任何內容，應確保不違反任何法律法規，不侵害他人的權利。</li>
            <li>使用者有責任確保其使用從本網站獲得的 AI 生成內容均符合著作權等智慧財產權之相關法律，並在使用該內容（如轉載、分享、或商業應用）時，取得必要的授權或許可，使用者違反相關法令或不當使用AI 生成內容所產生之任何損失或損害，本網站及其運營方不承擔任何法律責任。</li>
          </ul>
          <p>本網站保留隨時修改本免責聲明及智慧財產權聲明之權利，使用者應定期查閱免責聲明，以瞭解相關政策及任何變更。</p>

          <p class="font-bold">引用來源 :</p>

          <a class="block underline" href="https://support.microsoft.com/zh-tw/topic/%E4%BB%80%E9%BA%BC%E6%98%AF%E8%B2%A0%E8%B2%AC%E4%BB%BB%E7%9A%84-ai-33fc14be-15ea-4c2c-903b-aa493f5b8d92">MICROSOFT 負責任AI 說明</a>
          <a class="block underline" href="https://openai.com/policies/terms-of-use/">OPENAI使用條款</a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Policy',
  metaInfo () {
    return {
      title: '免責聲明',
      titleTemplate: null
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    li {
      margin-bottom: 1rem;
      .child-ul {
        list-style-type: cjk-ideographic;
        li {
          margin-bottom: 0rem;
        }
      }
    }
  }
</style>
